import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
import { windows } from '@/components/common/window/Windows';
import _ from 'lodash';
import { SelectRemoteFieldType } from '@/components/business/crud/interface/FieldType';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { ColumnEdit } from '@/components/business/crud/widgets/TableWidgetContainer';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectRemoteTable',
  props: {
    columnEdit: { type: Function },
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;
const values = computed(() => {
  if (props.widget.multi) {
    return (
      props.data[props.propName]?.list.map((i: any) => {
        return {
          label: i[props.widget.labelFieldName],
          value: i[props.widget.valueFieldName],
        };
      }) || []
    );
  } else {
    if (props.data[props.propName]) {
      return [
        {
          label: _.get(props.data, [
            props.propName,
            props.widget.labelFieldName,
          ]),
          value: _.get(props.data, [
            props.propName,
            props.widget.valueFieldName,
          ]),
        },
      ];
    } else {
      return [];
    }
  }
});

function open(item: { value: string }) {
  if (item?.value && props.widget.viewPagePath) {
    windows.open({
      content: {
        type: 'route',
        href: props.widget.viewPagePath.replace('__value__', item.value),
      },
      title: props.info.title + '详情',
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!

  return (_ctx.widget.multi)
    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(values.value, (item, k) => {
        return (_openBlock(), _createBlock(_component_a_tag, {
          key: k,
          onClick: () => open(item),
          style: {"cursor":"pointer"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.label || item.value), 1)
          ]),
          _: 2
        }, 1032, ["onClick"]))
      }), 128))
    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(values.value, (item, k) => {
        return (_openBlock(), _createBlock(ScBtn, {
          key: k,
          text: item.label || item.value,
          type: "link",
          handler: () => open(item)
        }, null, 8, ["text", "handler"]))
      }), 128))
}
}

})